export default __webpack_public_path__ + "static/media/mask.a4b3057c.png";